<template>
  <div class="wh100">
    <div ref="editMap" class="edit-map" v-show="mapMode=='edit'"></div>

    <div class="app-map-container" v-show="mapMode=='app'">
      <div ref="appMap" class="app-map"></div>
    </div>

    <div class="hq-map-container" v-show="mapMode=='hq'">
      <div ref="hqMap" class="hq-map"></div>
      <div><img src="@/assets/overlay-hq.png" class="hq-overlay"/></div>
    </div>

    <div >
      <input ref="searchBox" type="text" class="form-control search-box" placeholder="Location"/>

    </div>

    <div class="tools">
      <div v-if="mode=='edit'">
        <button class="btn btn-danger btn-sm" style="margin-bottom: 0.5rem;" @click="askResetMarker">Reset Marker</button>
      </div>
      <div>
        <button class="btn btn-danger btn-sm" @click="fitBounds">Fit Map</button>
      </div>
    </div>

  </div>
</template>

<script>

  import geodist from 'geodist';

  export default {
    name: "google-map",
    props: [
      'mode',
      'enterRadius',
      'exitRadius',
      'waypointRadius',
      'enterRadiusWP2',
      'exitRadiusWP2',
      'waypointRadiusWP2',
      'speed',
      'quizTime'
    ],
    data() {
      return {
        mapMode: 'edit'

      }
    },
    watch: {
      enterRadius: function (newVal, oldVald) {
        this.updateEnterRadius(newVal);
      },
      exitRadius: function (newVal, oldVald) {
        this.updateExitRadius(newVal);
      },
      waypointRadius: function (newVal, oldVald) {
        this.updateWaypointRadius(newVal);
      },
      enterRadiusWP2: function (newVal, oldVald) {
        this.updateEnterRadiusWP2(newVal);
      },
      exitRadiusWP2: function (newVal, oldVald) {
        this.updateExitRadiusWP2(newVal);
      },
      waypointRadiusWP2: function (newVal, oldVald) {
        this.updateWaypointRadiusWP2(newVal);
      },
      speed: function (newVal, oldVald) {
        this.updateSpeed(newVal);
      }
    },
    mounted: function () {
      const element = this.$refs.map;
      const style = [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ebe3cd"
            }
          ]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#523735"
            }
          ]
        },
        {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#f5f1e6"
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#c9b2a6"
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#dcd2be"
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#ae9e90"
            }
          ]
        },
        {
          "featureType": "landscape.natural",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dfd2ae"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dfd2ae"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#93817c"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#a5b076"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#447530"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f5f1e6"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#fdfcf8"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f8c967"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#e9bc62"
            }
          ]
        },
        {
          "featureType": "road.highway.controlled_access",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e98d58"
            }
          ]
        },
        {
          "featureType": "road.highway.controlled_access",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#db8555"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#806b63"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dfd2ae"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#8f7d77"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#ebe3cd"
            }
          ]
        },
        {
          "featureType": "transit.station",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dfd2ae"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#b9d3c2"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#92998d"
            }
          ]
        }
      ];

      const options = {
        zoom: 14,
        center: new google.maps.LatLng(10, 10),
        styles: style
      };

      this.editMap = new google.maps.Map(this.$refs.editMap, options);
      // options.disableDefaultUI = true;
      //options.styles = this.styles;

      // this.searchMarker = new google.maps.Marker({
      //   position: {lat: 0, lng: 0},
      //   map: this.editMap
      // });


      this.hqMap = new google.maps.Map(this.$refs.hqMap, options);
      this.appMap = new google.maps.Map(this.$refs.appMap, options);


      this.marker0 = this.createMarker('HQ');
      this.marker1 = this.createMarker('1');
      this.marker2 = this.createMarker('2');
      this.marker3 = this.createMarker('3');

      this.mapModes = {
        edit: this.editMap,
        app: this.appMap,
        hq: this.hqMap
      };

      const box = this.$refs.searchBox;
      this.searchBox = new google.maps.places.SearchBox(box);
      this.editMap.controls[google.maps.ControlPosition.TOP_LEFT].push(box);

      this.searchBox.addListener('places_changed', () => {
        const places = this.searchBox.getPlaces();
        console.log(places);
        if (places.length == 0) return;
        const place = places[0];
        const bounds = new google.maps.LatLngBounds();
        if (place.geometry.viewport) {
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
        // this.searchMarker.setPosition(place.geometry.location);
        this.editMap.setCenter(bounds.getCenter());
        this.editMap.fitBounds(bounds);

      });

    },
    methods: {
      setMode(mode) {
        this.mapMode = mode;
        const map = this.mapModes[mode];
        this.marker0.setMap(map);
        this.marker1.setMap(map);
        this.marker2.setMap(map);
        this.marker3.setMap(map);

        this.marker0.setDraggable(mode == 'edit');
        this.marker1.setDraggable(mode == 'edit');
        this.marker2.setDraggable(mode == 'edit');
        this.marker3.setDraggable(mode == 'edit');
      },

      redrawMarkers() {
        this.marker0.setPosition(this.marker0.getPosition());
        this.marker1.setPosition(this.marker1.getPosition());
        this.marker2.setPosition(this.marker2.getPosition());
        this.marker3.setPosition(this.marker3.getPosition());
      },
      updateEnterRadius(radius) {
        this.marker0.enterRadius.radius = radius;
        this.marker1.enterRadius.radius = radius;
        this.marker3.enterRadius.radius = radius;
        this.updateSpeed(this.speed);
        this.redrawMarkers();
      },

      updateExitRadius(radius) {
        this.marker0.exitRadius.radius = radius;
        this.marker1.exitRadius.radius = radius;
        this.marker3.exitRadius.radius = radius;
        this.updateSpeed(this.speed);
        this.redrawMarkers();
      },

      updateWaypointRadius(radius) {
        this.marker0.waypointRadius.radius = radius;
        this.marker1.waypointRadius.radius = radius;
        this.marker3.waypointRadius.radius = radius;
        this.redrawMarkers();
      },

      updateEnterRadiusWP2(radius) {
        this.marker2.enterRadius.radius = radius;
        this.updateSpeed(this.speed);
        this.redrawMarkers();
      },

      updateExitRadiusWP2(radius) {
        this.marker2.exitRadius.radius = radius;
        this.updateSpeed(this.speed);
        this.redrawMarkers();
      },

      updateWaypointRadiusWP2(radius) {
        this.marker2.waypointRadius.radius = radius;
        this.redrawMarkers();
      },

      updateSpeed(value) {
        console.log('update speed', value);
        const ms = value / 3.6;
        const time = this.quizTime;

        const radius = time * ms;
        const radius2 = this.exitRadius + radius;

        this.marker0.enterRadiusSpeed.radius = radius;
        this.marker1.enterRadiusSpeed.radius = radius;
        this.marker2.enterRadiusSpeed.radius = radius;
        this.marker3.enterRadiusSpeed.radius = radius;

        this.marker0.exitRadiusSpeed.radius = radius2;
        this.marker1.exitRadiusSpeed.radius = radius2;
        this.marker2.exitRadiusSpeed.radius = this.exitRadiusWP2 + radius;
        this.marker3.exitRadiusSpeed.radius = radius2;

        this.redrawMarkers();


      },

      fitBounds() {
        const map = this.mapModes[this.mode];
        const bounds = new google.maps.LatLngBounds();
        bounds.extend(this.marker0.getPosition());
        bounds.extend(this.marker1.getPosition());
        bounds.extend(this.marker2.getPosition());
        bounds.extend(this.marker3.getPosition());
        console.log(bounds.getCenter());
        map.setCenter(bounds.getCenter());
        map.fitBounds(bounds);
        // map.setZoom(map.getZoom()+1);
      },

      setMapData(data) {
        this.mapData = data;

        console.log('setMapData');

        this.editMap.setCenter(this.toLatLang(data.centerPosApp));

        this.appMap.setCenter(this.toLatLang(data.centerPosApp));
        this.appMap.setZoom(data.zoomApp);

        this.hqMap.setCenter(this.toLatLang(data.centerPosHQ));
        this.hqMap.setZoom(data.zoomHQ);

        this.marker0.setPosition(this.toLatLang(data.m0Pos));
        this.marker1.setPosition(this.toLatLang(data.m1Pos));
        this.marker2.setPosition(this.toLatLang(data.m2Pos));
        this.marker3.setPosition(this.toLatLang(data.m3Pos));

        // console.log("!!", this.$props.exitRadius, this.marker0.exitRadius);

        this.updateSpeed(this.speed);

      },

      getMapData() {

        return new Promise((resolve, reject) => {
          const options = {
            unit: 'meters',
            exact: false
          };


          const time = 200;

          this.setMode('app');
          setTimeout(() => {
            const appBounds = this.appMap.getBounds();
            const appNE = appBounds.getNorthEast();
            const appSW = appBounds.getSouthWest();
            const appNW = [appNE.lat(), appSW.lng()];
            const appSE = [appSW.lat(), appNE.lng()];
            const appWidth = geodist({lat: appNE.lat(), lon: appNE.lng()}, {lat: appNW[0], lon: appNW[1]}, options);
            const appHeight = geodist({lat: appSE[0], lon: appSE[1]}, {lat: appNE.lat(), lon: appNE.lng()}, options);
            console.log('app map size', appWidth, appHeight);

            this.setMode('hq');

            setTimeout(() => {
              const hqBounds = this.hqMap.getBounds();
              const hqNE = hqBounds.getNorthEast();
              const hqSW = hqBounds.getSouthWest();
              const hqNW = [hqNE.lat(), hqSW.lng()];
              const hqSE = [hqSW.lat(), hqNE.lng()];
              const hqWidth = geodist({lat: hqNE.lat(), lon: hqNE.lng()}, {lat: hqNW[0], lon: hqNW[1]}, options);
              const hqHeight = geodist({lat: hqSE[0], lon: hqSE[1]}, {lat: hqNE.lat(), lon: hqNE.lng()}, options);
              console.log('hq map size', hqWidth, hqHeight);

              const ret = {
                centerPosApp: this.toPosArray(this.appMap.getCenter()),
                zoomApp: this.appMap.getZoom(),
                nwPosApp: appNW,
                sePosApp: appSE,
                mapSizeApp: [appWidth, appHeight],

                centerPosHQ: this.toPosArray(this.hqMap.getCenter()),
                zoomHQ: this.hqMap.getZoom(),
                nwPosHQ: hqNW,
                sePosHQ: hqSE,
                mapSizeHQ: [hqWidth, hqHeight],

                m0Pos: this.toPosArray(this.marker0.getPosition()),
                m1Pos: this.toPosArray(this.marker1.getPosition()),
                m2Pos: this.toPosArray(this.marker2.getPosition()),
                m3Pos: this.toPosArray(this.marker3.getPosition())


              };

              resolve(ret);

              this.setMode(this.$props.mode);

            }, time);

          }, time);

        });

      },
      toLatLang(pos) {
        return {lat: pos[0], lng: pos[1]};
      },
      toPosArray(latLang) {
        return [latLang.lat(), latLang.lng()];
      },
      askResetMarker() {
        const v = confirm("Marker Positionen reseten?");
        if (v) this.resetMarker();
      },
      resetMarker() {
        const pos = this.editMap.getCenter();
        this.marker0.setPosition(pos);
        this.marker1.setPosition(pos);
        this.marker2.setPosition(pos);
        this.marker3.setPosition(pos);
      },
      createMarker(label) {
        const marker = new google.maps.Marker({
          position: {lat: 0, lng: 0},
          map: this.editMap,
          label: label,
          draggable: true,
          zIndex:100
        });


        marker.enterRadius = new google.maps.Circle({
          center: marker.center,
          map: this.editMap,
          strokeColor: '#0000FF',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillOpacity: 0,
          clickable: false,
          radius: 0
        });
        marker.enterRadius.bindTo('center', marker, 'position');
        marker.enterRadius.bindTo('map', marker);

        marker.exitRadius = new google.maps.Circle({
          center: marker.center,
          map: this.editMap,
          strokeColor: '#FF0000',
          strokeOpacity: 1,
          strokeWeight: 1,
          fillOpacity: 0,
          clickable: false,
          radius: 0
        });

        marker.exitRadius.bindTo('center', marker, 'position');
        marker.exitRadius.bindTo('map', marker);

        marker.waypointRadius = new google.maps.Circle({
          center: marker.center,
          map: this.editMap,
          strokeColor: '#20BB2C',
          strokeOpacity: 1,
          strokeWeight: 1,
          fillOpacity: 0,
          clickable: false,
          radius: 0
        });

        marker.waypointRadius.bindTo('center', marker, 'position');
        marker.waypointRadius.bindTo('map', marker);


        marker.exitRadiusSpeed = new google.maps.Circle({
          center: marker.center,
          map: this.editMap,
          strokeColor: '#ff0000',
          strokeOpacity: 0.15,
          fillOpacity: 0,
          clickable: false,
          strokeWeight: 7,
          radius: 0
        });

        marker.exitRadiusSpeed.bindTo('center', marker, 'position');
        marker.exitRadiusSpeed.bindTo('map', marker);


        marker.enterRadiusSpeed = new google.maps.Circle({
          center: marker.center,
          map: this.editMap,
          strokeColor: '#0000FF',
          strokeOpacity: 0.15,
          strokeWeight: 7,
          fillOpacity: 0,
          clickable: false,
          radius: 0
        });

        marker.enterRadiusSpeed.bindTo('center', marker, 'position');
        marker.enterRadiusSpeed.bindTo('map', marker);


        return marker;
      },
      createMaps() {

      }
    }
  }
</script>

<style lang="scss" scoped>

  .edit-map {
    width: 100%;
    height: calc(100% - 70px);
  }

  $appWidth: 1112px;
  $appHeight: 834px;

  $hqWidth: 768px;
  $hqHeight: 432px;

  .app-map-container {
    width: $appWidth;
    height: $appHeight;
    overflow: hidden;

  }

  .app-map {
    width: $appWidth;
    height: $appHeight;
  }

  .hq-map-container {
    position: relative;
    width: $hqWidth;
    height: $hqHeight;
    overflow: hidden;
  }

  .hq-overlay {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
  }

  .hq-map {
    width: $hqWidth;
    height: $hqHeight;
  }

  .search-box {

    width: 300px;
    margin-top: 5px;
  }

  .tools {
    position: absolute;
    bottom: 10px;
    left: 10px;
    z-index: 100;
  }

</style>



// WEBPACK FOOTER //
// src/components/maps/GoogleMap.vue